import { DefaultError } from 'errors/DefaultError';

type ErrorResponse = {
  config?: {
    method?: string;
    url?: string;
  };
  status?: number | string;
  statusText?: string;
  data?: unknown;
};

export class SessionError extends DefaultError {
  constructor({ error }: { error?: ErrorResponse }) {
    const shortMsg = `${error?.config?.method?.toUpperCase()} ${
      error?.config?.url
    } ${error?.status} (${error?.statusText})`;

    super({
      error: new Error(shortMsg),
      name: SessionError.name,
      title: 'Session expired',
      message: 'Please go back and try getting your quote again.'
    });
    this.response = error?.data;
  }
  static get name() {
    return 'SessionError';
  }
}
